import { useEffect, useState } from "react";
import { ShieldCheck, LockSimple } from "@phosphor-icons/react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import api from "../../lib/api";

const ROLE_COLOR = {
  owner: "bg-[#0EA5E9]/10 text-[#0EA5E9]",
  hr: "bg-[#0284C7]/10 text-[#0284C7]",
  manager: "bg-[#16A34A]/10 text-[#16A34A]",
  employee: "bg-[#475569]/10 text-[#475569]",
};

export function RolesSettings() {
  const [roles, setRoles] = useState([]);
  useEffect(() => { api.get("/roles").then(({ data }) => setRoles(data || [])).catch(() => {}); }, []);

  return (
    <div className="space-y-4" data-testid="roles-section">
      <div>
        <div className="font-display text-xl font-semibold flex items-center gap-2">
          <ShieldCheck size={20} weight="duotone" color="#0EA5E9" /> Roles
        </div>
        <p className="text-sm text-[#475569] mt-1 flex items-center gap-1.5">
          <LockSimple size={14} /> Built-in roles (read-only). Custom roles &amp; permissions will arrive in a later release.
        </p>
      </div>
      <Card className="surface-card border-[#E2E8F0]">
        <CardContent className="p-0 divide-y divide-[#E2E8F0]">
          {roles.map((r) => (
            <div key={r.key} className="flex items-start justify-between gap-3 p-4" data-testid={`role-row-${r.key}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <Badge className={`${ROLE_COLOR[r.key] || ROLE_COLOR.employee} border-0`}>{r.label}</Badge>
                  <Badge variant="outline" className="text-[#94A3B8]">Built-in</Badge>
                </div>
                <p className="text-sm text-[#475569] mt-1.5">{r.description}</p>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}

export default RolesSettings;
